export enum CONCILIATION_ADJUSTMENT_CAUSES_PERMISSIONS {
  CONCILIATION_ADJUSTMENT_CAUSES_VIEW = 'CONCILIATION_ADJUSTMENTVIEW',
  CONCILIATION_ADJUSTMENT_CAUSES_WRITE = 'CONCILIATION_ADJUSTMENTWRITE',
}
